<sbnb-full-screen-modal [closeLink]="transactionRoute">
  <div class="flex items-center justify-center p-8 md:p-0">
    <div class="max-w-[640px] w-full">
      <h1 class="mb-6">Import Transactions</h1>

      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <h4>Upload a CSV file</h4>
          <p class="text-night">
            Import your transactions from a CSV file. Download our template, example file, categories list, and
            properties list to ensure proper formatting.
          </p>
        </div>

        <div class="flex flex-col gap-4">
          <div class="flex flex-wrap gap-2">
            <a
              (click)="downloadFile('template.csv', 'transactions/import/files/template.csv')"
              target="_blank"
              role="button"
              class="inline-flex items-center text-sm text-raspberry-darker hover:underline cursor-pointer">
              <sbnb-icon icon="download" [size]="14" class="mr-1"></sbnb-icon>
              Download Template
            </a>
            <a
              (click)="downloadFile('example.csv', 'transactions/import/files/example.csv')"
              target="_blank"
              role="button"
              class="inline-flex items-center text-sm text-raspberry-darker hover:underline cursor-pointer">
              <sbnb-icon icon="download" [size]="14" class="mr-1"></sbnb-icon>
              Download Example
            </a>
            <a
              (click)="downloadFile('categories.csv', 'transactions/import/files/categories.csv')"
              target="_blank"
              role="button"
              class="inline-flex items-center text-sm text-raspberry-darker hover:underline cursor-pointer">
              <sbnb-icon icon="download" [size]="14" class="mr-1"></sbnb-icon>
              Download Categories
            </a>
            <a
              (click)="downloadFile('properties.csv', 'transactions/import/files/properties.csv')"
              target="_blank"
              role="button"
              class="inline-flex items-center text-sm text-raspberry-darker hover:underline cursor-pointer">
              <sbnb-icon icon="download" [size]="14" class="mr-1"></sbnb-icon>
              Download Properties
            </a>
          </div>

          <sbnb-file-upload
            [multiple]="false"
            [maxSize]="10485760"
            [fileTypes]="['csv']"
            (filesSelected)="onFileSelected($event)"
            (fileRemoved)="onFileRemoved()"
            [disabled]="false"
            #fileUpload>
            <ng-template>
              <p class="font-medium m-0">
                Drag and drop your CSV file or
                <a (click)="fileUpload.openFileSelector()" class="text-raspberry-darker cursor-pointer" role="button">
                  click to browse
                </a>
              </p>
            </ng-template>
          </sbnb-file-upload>
        </div>

        @if (feedbackUrl) {
          <div class="flex flex-col gap-2 p-4 bg-lemon-lighter border border-lemon rounded-lg">
            <div class="flex items-center gap-2">
              <sbnb-icon icon="warning" [size]="16" class="text-raspberry-darker"></sbnb-icon>
              <h4 class="text-raspberry-darker">Import Failed</h4>
            </div>
            <p class="text-sm text-night">
              Some transactions could not be imported. The feedback file contains details about the errors and how to
              fix them.
            </p>
            <div class="flex flex-col gap-2">
              <p class="text-sm text-night m-0">To fix the issues:</p>
              <ol class="text-sm text-night list-decimal list-inside m-0 *:mb-0 space-y-1">
                <li>Download the feedback file below</li>
                <li>Review the error messages in the file</li>
                <li>Fix the issues in your CSV file</li>
                <li>Try importing again</li>
              </ol>
            </div>
          </div>
        }
      </div>

      <div class="flex justify-end mt-8">
        <sbnb-button type="secondary" label="Cancel" (click)="closeModal()"></sbnb-button>
        @if (feedbackUrl) {
          <sbnb-button class="ml-2" [disabled]="!selectedFile" (click)="downloadFeedbackFile()">
            Download feedback file
          </sbnb-button>
        } @else {
          <sbnb-button label="Import" class="ml-2" [disabled]="!selectedFile" (click)="importFile()"></sbnb-button>
        }
      </div>
    </div>
  </div>
</sbnb-full-screen-modal>
